import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "./store";

Vue.use(VueRouter)

import Dashboard from './components/Dashboard';
import UTC from './components/UTC';
import Alarms from './components/Alarms';
import Intrusions from './components/Intrusions';
import Screenshots from './components/Screenshots';
import Users from './components/Users';
import Organizations from './components/Organizations';
import Support from './components/Support';
import Login from './components/Login';
import Invite from './components/Invite';
import Account from './components/Account';

const routes = [
    {
        component: Invite,
        name: 'Invite',
        path: '/invite',
        meta: { requiresAuth: false }
    },
    {
        component: Login,
        name: 'Login',
        path: '/login',
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        component: Dashboard,
        name: '$vuetify.app.dashboard',
        path: '/dashboard',
        meta: { requiresAuth: true }
    },
    {
        component: UTC,
        name: 'UTC',
        path: '/utc',
        meta: { requiresAuth: true }
    },   
    {
        component: Alarms,
        name: '$vuetify.app.alarms',
        path: '/alarms',
        meta: { requiresAuth: true }
    },
    {
        component: Intrusions,
        name: 'Intrusions',
        path: '/intrusions',
        meta: { requiresAuth: true }
    },
    {
        component: Screenshots,
        name: '$vuetify.app.screenshots',
        path: '/screenshots',
        meta: { requiresAuth: true }
    },
    {
        component: Users,
        name: '$vuetify.app.users',
        path: '/Users',
        meta: { requiresAuth: true }
    },
    {
        component: Account,
        name: '$vuetify.app.account',
        path: '/account',
        meta: { requiresAuth: true }
    },
    {
        component: Support,
        name: '$vuetify.app.support',
        path: '/support',
        meta: { requiresAuth: true }
    },
    {
        component: Organizations,
        name: '$vuetify.app.organizations',
        path: '/organizations',
        meta: { requiresAuth: true }
    },
    {
        component: Login,
        name: '403 Forbidden Access',
        path: '/403',
    }
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            if (!store.getters.StateUser.orgaValid && ["/dashboard","/account","/organizations","/support"].indexOf(to.path) === -1 ) {
                next('/dashboard');
            } else {
                next();
            }
        } else {
            next("/login");
        }
    } else {
        if (store.getters.isAuthenticated) {
            if (to.path !== "/invite") {
                next('/dashboard');
            } else {
                next();
            }
        } else {
            next();
        }
        
    }
});

router.beforeEach((to, from, next) => {
    window.stop();
    next();
});

export default router;